import Alpine from 'alpinejs';

// Initialize Alpine plugins
window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {

  Alpine.data('indexPage', function() {
    return {
      activeTab: 'of',
      platforms: {
        instagram: {
          baseUrl: 'https://instagram.com/',
          borderColor: 'border-secondary-500',
          buttonColor: 'bg-gradient-to-r from-secondary-500 to-primary-500',
          logo: '/static/instalogo.webp'
        },
        twitter: {
          baseUrl: 'https://x.com/',
          borderColor: 'border-primary-500',
          buttonColor: 'bg-primary-500',
          logo: '/static/xlogo.png'
        },
        of: {
          baseUrl: 'https://onlyfans.com/',
          borderColor: 'border-accent-500',
          buttonColor: 'bg-accent-500',
          logo: '/static/oflogo.webp'
        },
        fansly: {
          baseUrl: 'https://fansly.com/',
          borderColor: 'border-accent-500',
          buttonColor: 'bg-accent-500',
          logo: '/static/Fansly-Logo.png'
        },
        custom: {
          baseUrl: 'https://',
          borderColor: 'border-gray-500',
          buttonColor: 'bg-gray-500',
          logo: ''
        }
      },
      handleSubmit() {
        const input = this.$refs.username.value.trim();
        const isUrl = input.startsWith('http://') || input.startsWith('https://');
        const targetUrl = isUrl ? input : this.platforms[this.activeTab].baseUrl + input;
        window.location.href = 'mailto:hello@mylinksprofile.com?body=Hello, I am interested in using MyLinksProfile. My first link is: ' + targetUrl;
      }
    }
  })

});

Alpine.start();

